import request from '../network';

export const getInstanceStatusEnumApi = (shopId: any) => {
  return request({
    url: `/member/royalcanin/admin/points/exchange/product-instance/${shopId}/enum/instance-status`,
    method: 'GET',
  });
};

export const getInstanceListApi = (shopId: any, params: any) => {
  return request({
    url: `/member/royalcanin/admin/points/exchange/product-instance/${shopId}/list`,
    method: 'GET',
    params,
  });
};

export const addInstanceApi = (shopId: any, data: any) => {
  return request({
    url: `/member/royalcanin/admin/points/exchange/product-instance/${shopId}/add`,
    method: 'POST',
    data,
  });
};

export const updateInstanceApi = (shopId: any, data: any) => {
  return request({
    url: `/member/royalcanin/admin/points/exchange/product-instance/${shopId}/update`,
    method: 'POST',
    data,
  });
};

export const getInstanceDetailApi = (shopId: any, id: any) => {
  return request({
    url: `/member/royalcanin/admin/points/exchange/product-instance/${shopId}/detail/${id}`,
    method: 'GET',
  });
};

export const publishInstanceApi = (shopId: any, instanceId: any, allocatedStock?: number, remark?: string) => {
  return request({
    url: `/member/royalcanin/admin/points/exchange/product-instance/${shopId}/publish/${instanceId}`,
    method: 'GET',
    params: { allocatedStock, remark },
  });
};

export const unpublishInstanceApi = (shopId: any, instanceId: any) => {
  return request({
    url: `/member/royalcanin/admin/points/exchange/product-instance/${shopId}/unpublish/${instanceId}`,
    method: 'GET',
  });
};

export const deleteInstanceApi = (shopId: any, id: any) => {
  return request({
    url: `/member/royalcanin/admin/points/exchange/product-instance/${shopId}/delete/${id}`,
    method: 'GET',
  });
};
